import ArticleServiceForm from '@/components/ArticleServiceForm'
import { ArticleService, SharedProps } from '@/types'
import { Head, Link } from '@inertiajs/react'
import { Button, Group, Paper, Stack, Title } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'

interface ArticleServiceEditProps extends SharedProps {
  article_service: ArticleService
}

export default function ArticleServiceEdit({ article_service, current_organization }: ArticleServiceEditProps) {
  return (
    <>
      <Head title={`Modifier: ${article_service.service_name} - ${current_organization?.name}`} />

      <Stack gap="xl">
        <Group justify="space-between">
          <Button
            component={Link}
            href={`/organizations/${current_organization?.slug}/article_services`}
            variant="subtle"
            color="gray"
            leftSection={<IconArrowLeft size={16} />}
          >
            Retour au catalogue
          </Button>
        </Group>

        <Paper withBorder p="xl" radius="md">
          <Stack gap="xl">
            <Title order={2}>Modifier le service</Title>

            <ArticleServiceForm initialData={article_service} action="edit" />
          </Stack>
        </Paper>
      </Stack>
    </>
  )
}
